import React from "react";
import { connect } from "react-redux";
import * as actions from "../../Users/actions.es6"
import { formatDateLocale } from "../../../lib/utils.es6";
import TableInc from "../../../shared-ui/TableInc";
import SkeletonWrapper from "../../NewProductList/components/SkeletonWrapper/SkeletonWrapper";
import Grid from "@material-ui/core/Grid";
import { DatePicker } from '@material-ui/pickers';
import ButtonInc from "../../../shared-ui/ButtonInc";
import {Select, InputLabel} from "@mui/material";
import MenuItem from '@mui/material/MenuItem';

class UserActivityAudit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: null,
      toDate: null,
      size : 10
    };
  }

  componentWillMount() {
   
      const payload = {
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        size: this.state.size
      }

    this.props.dispatch(actions.getAllUsersAuthActivitiesRequest(payload));

  }

  getAudits = (pagingData) => {
    const payload = {
      size: pagingData.size || this.state.size,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate
    };
     this.props.dispatch(actions.getAllUsersAuthActivitiesRequest(payload));
  };

  render() {
    const { userData } = this.props;

    const audits = { events: userData.usersAuthActivities, size: userData.usersAuthActivities && userData.usersAuthActivities.length, page: userData.page, count: userData.count } || {
      events: [],
      size: this.state.size,
      page: this.state.page,
      count: 0,
    };
    const events = audits.events;

    if (userData.usersAuthActivitiesLoader) {
      return <SkeletonWrapper loading={true} />;
    }

    if (userData.usersAuthActivitiesError) {
      return <div>
        <p>error: {userData.usersAuthActivitiesError ? userData.usersAuthActivitiesError : ""}</p>
      </div>
    }

    return (
      <section className="">
          <Grid container spacing={2} style={{ marginBottom: '16px', display: 'flex', gap: '10px', alignItems: 'end', backgroundColor:'white', padding: '10px' }}>  
          <p style={{ fontWeight: 'bold' }}>Filter by:</p>
            <div style={{
              backgroundColor:"#fff",
              padding: '6px',
              display: 'flex',
              gap: '16px',
              justifyContent: 'start',
              alignItems: 'end'
            }}>
              
             <DatePicker label="From Date" id='fromDate'  
               value={this.state.fromDate} 
              onChange={(newValue) => this.setState({ fromDate: newValue })} 
              name='fromDate' />
              <DatePicker label="To Date" id='toDate' 
              value={this.state.toDate} 
              onChange={(newValue) => this.setState({ toDate: newValue })} 
              name='toDate' />
              <Grid style={{ minWidth: 120, display: 'flex', flexDirection: 'row', alignItems: 'end', justifyContent: 'center', gap: '8px' }}>
                <InputLabel id="size-label">Size</InputLabel>
                <Select
                label="Size"
                value={this.state.size}
                onChange={(event) => this.setState({ size: event.target.value })}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
              </Grid>
              
               <ButtonInc
                variant="contained" 
                onClick={() => this.getAudits({ fromDate: this.state.fromDate, toDate: this.state.toDate, size: this.state.size })}
              >
                Filter
              </ButtonInc>
            </div>
      </Grid>
      <TableInc
        columns={[
          { title: "Event Type", field: "event_type" },
          { title: "Description", field: "description" },
          { title: "Full Name", field: "full_name" },
          { title: "IP Address", field: "ip_address" },
          {
            title: "Created At",
            field: "created_at",
            render: (rowData) => formatDateLocale(rowData.created_at),
          },
        ]}
        data={(query) =>
          new Promise((resolve, reject) => {
            resolve({
              data: [...events],
              page: this.state.page,
              totalCount: audits.count,
            });
          })
        }
        options={{
          showTitle: false,
          pageSizeOptions: [1, 5, 10, 20, 50, 100],
          pageSize: this.state.size,
          paging: false
        }}
        onChangeRowsPerPage={(pageSize) => {
          this.setState({ size: pageSize });
          this.getAudits({ size: pageSize });
        }}
        onChangePage={(page) => {
          this.setState({ page: page });
          this.getAudits({ page: page + 1 });
        }}
      />
      </section>
    );
  }
}

export default connect((state) => ({
  userData: state.userAdmin,
}))(UserActivityAudit);
